import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

import RevitBuiltInParameters from "./RevitBuiltInParameters.graphql";

export default function useRevitBuiltInParameter(id) {
    const revitBuiltInParameters = useQuery(
        gql(RevitBuiltInParameters),
    );

    return {
        ...revitBuiltInParameters,
        data: revitBuiltInParameters.data
            ? {
                revitBuiltInParameter: revitBuiltInParameters
                    .data
                    ?.revitBuiltInParameters
                    ?.find(
                        (parameter) => String(parameter.id) === String(id)
                    ),
            }
            : undefined,
    };
}
